import React, { useEffect, useState, useContext } from "react";
import "./dashboard.css";
import logo from "./clevr.png";

import { getLogs } from "./api/logService";
import LogTable from "./components/LogTable";
import GroupedLogs from "./components/GroupedLogs";
import PayloadsPage from "./components/PayloadsPage";
import CanonicalLogPage from "./components/CanonicalLogPage";
import ProcessLogPage from "./components/ProcessLogPage";
import ProtectedRoute from "./auth/ProtectedRoute";
import { AuthContext } from "./auth/AuthContext";

function App() {
  const [logs, setLogs] = useState([]);
  const [activeTab, setActiveTab] = useState("supplier");
  const [darkMode, setDarkMode] = useState(false);
  const [currentPage, setCurrentPage] = useState("logs");
  const { user, logout } = useContext(AuthContext);

  const loadLogs = async () => {
    try {
      const data = await getLogs();
      setLogs(data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)));
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  useEffect(() => {
    loadLogs();
    const interval = setInterval(loadLogs, 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark");
  };

  const bomLogs = logs.filter((log) => log.entityType === "BOM");
  const supplierLogs = logs.filter((log) => log.entityType === "SUPPLIER");
  const articleLogs = logs.filter((log) => log.entityType === "ARTICLE");

  return (
    <ProtectedRoute>
      <div>
        {/* HEADER BAR */}
        <div className="header-bar">
          <div className="header-top">
            <div className="header-left">
              <img src={logo} alt="Company Logo" className="header-logo" />
              <span className="header-title">
                Apache Camel / Kafka Middleware Dashboard
              </span>
            </div>
            <div className="header-right">
              {user && (
                <span className="header-user">&#128100; {user.username}</span>
              )}
              <button className="dark-toggle" onClick={toggleDarkMode}>
                {darkMode ? "☀ Light Mode" : "🌙 Dark Mode"}
              </button>
              <button className="btn-logout" onClick={logout}>
                Logout
              </button>
            </div>
          </div>

          {/* TOP NAV */}
          <nav className="top-nav">
            <button
              className={currentPage === "logs" ? "active" : ""}
              onClick={() => setCurrentPage("logs")}
            >
              Process Logs
            </button>
            <button
              className={currentPage === "payloads" ? "active" : ""}
              onClick={() => setCurrentPage("payloads")}
            >
              IDoc Payloads
            </button>
            <button
              className={currentPage === "canonical" ? "active" : ""}
              onClick={() => setCurrentPage("canonical")}
            >
              Canonical Log
            </button>
            <button
              className={currentPage === "processlogs" ? "active" : ""}
              onClick={() => setCurrentPage("processlogs")}
            >
              Process Log Search
            </button>
          </nav>
        </div>

        {/* PROCESS LOGS PAGE */}
        {currentPage === "logs" && (
          <>
            <div className="tabs">
              <button
                className={activeTab === "supplier" ? "active" : ""}
                onClick={() => setActiveTab("supplier")}
              >
                Supplier
              </button>
              <button
                className={activeTab === "article" ? "active" : ""}
                onClick={() => setActiveTab("article")}
              >
                Article
              </button>
              <button
                className={activeTab === "bom" ? "active" : ""}
                onClick={() => setActiveTab("bom")}
              >
                BOM
              </button>
            </div>

            <div className="tab-content">
              {activeTab === "bom" && (
                <div>
                  <div className="card">
                    <h2>Grouped by Correlation ID</h2>
                    <GroupedLogs logs={bomLogs} entityType="BOM" />
                  </div>
                  <div className="card">
                    <h2>Raw BOM Import Logs</h2>
                    <LogTable logs={bomLogs} entityType="BOM" />
                  </div>
                </div>
              )}
              {activeTab === "article" && (
                <div>
                  <div className="card">
                    <h2>Grouped by Correlation ID</h2>
                    <GroupedLogs logs={articleLogs} entityType="ARTICLE" />
                  </div>
                  <div className="card">
                    <h2>Raw ARTICLE Import Logs</h2>
                    <LogTable logs={articleLogs} entityType="ARTICLE" />
                  </div>
                </div>
              )}
              {activeTab === "supplier" && (
                <div>
                  <div className="card">
                    <h2>Grouped by Correlation ID</h2>
                    <GroupedLogs logs={supplierLogs} entityType="SUPPLIER" />
                  </div>
                  <div className="card">
                    <h2>Raw SUPPLIER Import Logs</h2>
                    <LogTable logs={supplierLogs} entityType="SUPPLIER" />
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* IDOC PAYLOADS PAGE */}
        {currentPage === "payloads" && (
          <div className="tab-content">
            <PayloadsPage />
          </div>
        )}

        {/* CANONICAL LOG PAGE */}
        {currentPage === "canonical" && (
          <div className="tab-content">
            <CanonicalLogPage />
          </div>
        )}

        {/* PROCESS LOG SEARCH PAGE */}
        {currentPage === "processlogs" && (
          <div className="tab-content">
            <ProcessLogPage />
          </div>
        )}
      </div>
    </ProtectedRoute>
  );
}

export default App;
